// actions/catalog/categories.js

import { attachAuth } from '../../utils/authService';

// --- ALL ---

export function categoriesHasErrored(bool) {
  return {
    type: 'CATEGORIES_HAS_ERRORED',
    hasErrored: bool
  };
}

export function categoriesIsLoading(bool) {
  return {
    type: 'CATEGORIES_IS_LOADING',
    isLoading: bool
  };
}

export function categoriesFetchDataSuccess(items) {
  return {
    type: 'CATEGORIES_FETCH_DATA_SUCCESS',
    items
  };
}

export function categoriesFetchData(host) {
  return (dispatch) => {
    dispatch(categoriesIsLoading(true));
    dispatch(categoriesHasErrored(false));
    fetch(host + 'catalog/categories', {
      method: 'get',
      headers: attachAuth()
    }).then(promise => {
        if (!promise.ok) {
          throw Error(promise.statusText);
        }
        
        promise.json()
          .then(result => {
            dispatch(categoriesFetchDataSuccess(result));
            dispatch(categoriesHasErrored(false));
            dispatch(categoriesIsLoading(false));
          })
          .catch((ex) => {
            console.log(ex);
            dispatch(categoriesHasErrored(true));
            dispatch(categoriesIsLoading(false));
          });
    })
    .catch((ex) => {
      console.log(ex);
      dispatch(categoriesHasErrored(true));
      dispatch(categoriesIsLoading(false));
    });
  };
}